// Comprehensive Saints Database with first names mapping
// Extended database with 150+ first names

export const saintsDatabase = {
  // A
  'adam': {
    saint: { fr: 'Saint Adam', en: 'Saint Adam' },
    feastDay: { fr: '24 décembre', en: 'December 24' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Adam, le premier homme créé par Dieu selon la Bible, est vénéré comme saint dans plusieurs traditions chrétiennes.',
      en: 'Adam, the first man created by God according to the Bible, is venerated as a saint in several Christian traditions.'
    }
  },
  'adele': {
    saint: { fr: 'Sainte Adèle', en: 'Saint Adele' },
    feastDay: { fr: '24 décembre', en: 'December 24' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Adèle de Pfalzel était une princesse franque du VIIe siècle qui fonda un monastère et vécut dans la sainteté.',
      en: 'Saint Adele of Pfalzel was a Frankish princess of the 7th century who founded a monastery and lived in holiness.'
    }
  },
  'adrien': {
    saint: { fr: 'Saint Adrien', en: 'Saint Adrian' },
    feastDay: { fr: '8 septembre', en: 'September 8' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Adrien de Nicomédie était un officier romain martyrisé au IVe siècle pour sa foi chrétienne.',
      en: 'Saint Adrian of Nicomedia was a Roman officer martyred in the 4th century for his Christian faith.'
    }
  },
  'agathe': {
    saint: { fr: 'Sainte Agathe', en: 'Saint Agatha' },
    feastDay: { fr: '5 février', en: 'February 5' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Sainte Agathe de Sicile fut une vierge et martyre du IIIe siècle, patronne des pompiers et contre les éruptions volcaniques.',
      en: 'Saint Agatha of Sicily was a virgin and martyr of the 3rd century, patron saint of firefighters and against volcanic eruptions.'
    }
  },
  'agnes': {
    saint: { fr: 'Sainte Agnès', en: 'Saint Agnes' },
    feastDay: { fr: '21 janvier', en: 'January 21' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Agnès de Rome fut une vierge et martyre du IVe siècle, morte à 12 ans pour avoir refusé de renier sa foi.',
      en: 'Saint Agnes of Rome was a virgin and martyr of the 4th century, who died at 12 for refusing to deny her faith.'
    }
  },
  'alain': {
    saint: { fr: 'Saint Alain', en: 'Saint Alan' },
    feastDay: { fr: '9 septembre', en: 'September 9' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Alain de la Roche était un dominicain breton du XVe siècle, grand propagateur de la dévotion au Rosaire.',
      en: 'Saint Alan de la Roche was a Breton Dominican of the 15th century, great propagator of devotion to the Rosary.'
    }
  },
  'albert': {
    saint: { fr: 'Saint Albert le Grand', en: 'Saint Albert the Great' },
    feastDay: { fr: '15 novembre', en: 'November 15' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Albert le Grand (1200-1280) était un évêque dominicain allemand, docteur de l\'Église et maître de saint Thomas d\'Aquin.',
      en: 'Saint Albert the Great (1200-1280) was a German Dominican bishop, Doctor of the Church and teacher of Saint Thomas Aquinas.'
    }
  },
  'alexandre': {
    saint: { fr: 'Saint Alexandre', en: 'Saint Alexander' },
    feastDay: { fr: '22 avril', en: 'April 22' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Alexandre fut évêque d\'Alexandrie au IVe siècle. Il combattit l\'hérésie arienne.',
      en: 'Saint Alexander was Bishop of Alexandria in the 4th century. He fought against the Arian heresy.'
    }
  },
  'alexis': {
    saint: { fr: 'Saint Alexis', en: 'Saint Alexis' },
    feastDay: { fr: '17 juillet', en: 'July 17' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Alexis de Rome était un noble romain qui vécut en mendiant sous l\'escalier de la maison de ses parents.',
      en: 'Saint Alexis of Rome was a Roman noble who lived as a beggar under the stairs of his parents\' house.'
    }
  },
  'alice': {
    saint: { fr: 'Sainte Alice', en: 'Saint Alice' },
    feastDay: { fr: '16 décembre', en: 'December 16' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Alice de Schaerbeek fut une moniale cistercienne du XIIIe siècle connue pour sa grande piété.',
      en: 'Saint Alice of Schaerbeek was a Cistercian nun of the 13th century known for her great piety.'
    }
  },
  'aline': {
    saint: { fr: 'Sainte Aline', en: 'Saint Aline' },
    feastDay: { fr: '20 octobre', en: 'October 20' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Aline de Belgique fut une vierge et martyre du VIIe siècle, morte pour avoir refusé un mariage.',
      en: 'Saint Aline of Belgium was a virgin and martyr of the 7th century, who died for refusing a marriage.'
    }
  },
  'alphonse': {
    saint: { fr: 'Saint Alphonse de Liguori', en: 'Saint Alphonsus Liguori' },
    feastDay: { fr: '1er août', en: 'August 1' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Alphonse de Liguori (1696-1787) était un évêque italien, fondateur des Rédemptoristes et Docteur de l\'Église.',
      en: 'Saint Alphonsus Liguori (1696-1787) was an Italian bishop, founder of the Redemptorists and Doctor of the Church.'
    }
  },
  'amandine': {
    saint: { fr: 'Sainte Amandine', en: 'Saint Amandine' },
    feastDay: { fr: '9 juillet', en: 'July 9' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Bienheureuse Amandine était une religieuse franciscaine belge martyrisée en Chine en 1900.',
      en: 'Blessed Amandine was a Belgian Franciscan nun martyred in China in 1900.'
    }
  },
  'amelie': {
    saint: { fr: 'Sainte Amélie', en: 'Saint Amelia' },
    feastDay: { fr: '19 septembre', en: 'September 19' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Amélie était une vierge consacrée du IXe siècle, modèle de piété et de charité.',
      en: 'Saint Amelia was a consecrated virgin of the 9th century, model of piety and charity.'
    }
  },
  'andre': {
    saint: { fr: 'Saint André', en: 'Saint Andrew' },
    feastDay: { fr: '30 novembre', en: 'November 30' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint André était l\'un des douze apôtres, frère de saint Pierre, crucifié sur une croix en forme de X.',
      en: 'Saint Andrew was one of the twelve apostles, brother of Saint Peter, crucified on an X-shaped cross.'
    }
  },
  'angelique': {
    saint: { fr: 'Sainte Angélique', en: 'Saint Angelica' },
    feastDay: { fr: '4 janvier', en: 'January 4' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Bienheureuse Angélique de Brescia était une religieuse augustine du XVe siècle.',
      en: 'Blessed Angelica of Brescia was an Augustinian nun of the 15th century.'
    }
  },
  'anne': {
    saint: { fr: 'Sainte Anne', en: 'Saint Anne' },
    feastDay: { fr: '26 juillet', en: 'July 26' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Anne était la mère de la Vierge Marie et grand-mère de Jésus. Elle est patronne des grands-mères.',
      en: 'Saint Anne was the mother of the Virgin Mary and grandmother of Jesus. She is patron saint of grandmothers.'
    }
  },
  'anthony': {
    saint: { fr: 'Saint Antoine de Padoue', en: 'Saint Anthony of Padua' },
    feastDay: { fr: '13 juin', en: 'June 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Antoine de Padoue (1195-1231) était un prêtre franciscain, célèbre prédicateur et thaumaturge.',
      en: 'Saint Anthony of Padua (1195-1231) was a Franciscan priest, famous preacher and miracle worker.'
    }
  },
  'antoine': {
    saint: { fr: 'Saint Antoine de Padoue', en: 'Saint Anthony of Padua' },
    feastDay: { fr: '13 juin', en: 'June 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Antoine de Padoue (1195-1231) était un prêtre franciscain portugais, célèbre prédicateur et thaumaturge.',
      en: 'Saint Anthony of Padua (1195-1231) was a Portuguese Franciscan priest, famous preacher and miracle worker.'
    }
  },
  'arnaud': {
    saint: { fr: 'Saint Arnaud', en: 'Saint Arnold' },
    feastDay: { fr: '18 juillet', en: 'July 18' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Arnaud de Metz était un évêque du VIe siècle, patron des brasseurs de bière.',
      en: 'Saint Arnold of Metz was a 6th century bishop, patron saint of beer brewers.'
    }
  },
  'arthur': {
    saint: { fr: 'Saint Arthur', en: 'Saint Arthur' },
    feastDay: { fr: '15 novembre', en: 'November 15' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Arthur était un martyr anglais du XVIe siècle, mort pour sa foi catholique.',
      en: 'Saint Arthur was an English martyr of the 16th century, who died for his Catholic faith.'
    }
  },
  'augustin': {
    saint: { fr: 'Saint Augustin', en: 'Saint Augustine' },
    feastDay: { fr: '28 août', en: 'August 28' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Augustin d\'Hippone (354-430) est l\'un des quatre Pères de l\'Église latine, auteur des Confessions.',
      en: 'Saint Augustine of Hippo (354-430) is one of the four Fathers of the Latin Church, author of the Confessions.'
    }
  },
  'aurelie': {
    saint: { fr: 'Sainte Aurélie', en: 'Saint Aurelia' },
    feastDay: { fr: '15 octobre', en: 'October 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Aurélie de Strasbourg était une princesse mérovingienne qui vécut en recluse.',
      en: 'Saint Aurelia of Strasbourg was a Merovingian princess who lived as a recluse.'
    }
  },
  'axel': {
    saint: { fr: 'Saint Axel', en: 'Saint Axel' },
    feastDay: { fr: '21 mars', en: 'March 21' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Axel (Absalon) était un archevêque danois du XIIe siècle, fondateur de Copenhague.',
      en: 'Saint Axel (Absalon) was a Danish archbishop of the 12th century, founder of Copenhagen.'
    }
  },
  // B
  'baptiste': {
    saint: { fr: 'Saint Jean-Baptiste', en: 'Saint John the Baptist' },
    feastDay: { fr: '24 juin', en: 'June 24' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Jean-Baptiste était le cousin de Jésus et le prophète qui baptisa le Christ dans le Jourdain.',
      en: 'Saint John the Baptist was the cousin of Jesus and the prophet who baptized Christ in the Jordan.'
    }
  },
  'barbara': {
    saint: { fr: 'Sainte Barbe', en: 'Saint Barbara' },
    feastDay: { fr: '4 décembre', en: 'December 4' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Sainte Barbe était une vierge et martyre du IIIe siècle, patronne des artilleurs et des pompiers.',
      en: 'Saint Barbara was a virgin and martyr of the 3rd century, patron saint of artillerymen and firefighters.'
    }
  },
  'bastien': {
    saint: { fr: 'Saint Sébastien', en: 'Saint Sebastian' },
    feastDay: { fr: '20 janvier', en: 'January 20' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Sébastien était un soldat romain martyrisé pour sa foi chrétienne, patron des athlètes.',
      en: 'Saint Sebastian was a Roman soldier martyred for his Christian faith, patron saint of athletes.'
    }
  },
  'beatrice': {
    saint: { fr: 'Sainte Béatrice', en: 'Saint Beatrice' },
    feastDay: { fr: '13 février', en: 'February 13' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Béatrice d\'Este était une bienheureuse italienne du XIIIe siècle.',
      en: 'Saint Beatrice of Este was an Italian blessed of the 13th century.'
    }
  },
  'benoit': {
    saint: { fr: 'Saint Benoît', en: 'Saint Benedict' },
    feastDay: { fr: '11 juillet', en: 'July 11' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Benoît de Nursie (480-547) est le fondateur de l\'ordre des Bénédictins et patron de l\'Europe.',
      en: 'Saint Benedict of Nursia (480-547) is the founder of the Benedictine order and patron saint of Europe.'
    }
  },
  'benjamin': {
    saint: { fr: 'Saint Benjamin', en: 'Saint Benjamin' },
    feastDay: { fr: '31 mars', en: 'March 31' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Benjamin était un diacre perse martyrisé au Ve siècle pour avoir refusé de renier sa foi.',
      en: 'Saint Benjamin was a Persian deacon martyred in the 5th century for refusing to deny his faith.'
    }
  },
  'bernadette': {
    saint: { fr: 'Sainte Bernadette Soubirous', en: 'Saint Bernadette Soubirous' },
    feastDay: { fr: '16 avril', en: 'April 16' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Bernadette (1844-1879) est la voyante des apparitions de Lourdes, devenue religieuse.',
      en: 'Saint Bernadette (1844-1879) is the visionary of the Lourdes apparitions, who became a nun.'
    }
  },
  'bernard': {
    saint: { fr: 'Saint Bernard de Clairvaux', en: 'Saint Bernard of Clairvaux' },
    feastDay: { fr: '20 août', en: 'August 20' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Bernard de Clairvaux (1090-1153) était un abbé cistercien et Docteur de l\'Église.',
      en: 'Saint Bernard of Clairvaux (1090-1153) was a Cistercian abbot and Doctor of the Church.'
    }
  },
  'bertrand': {
    saint: { fr: 'Saint Bertrand', en: 'Saint Bertrand' },
    feastDay: { fr: '16 octobre', en: 'October 16' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Bertrand de Comminges était un évêque du XIe siècle, réformateur de son diocèse.',
      en: 'Saint Bertrand of Comminges was an 11th century bishop, reformer of his diocese.'
    }
  },
  'brigitte': {
    saint: { fr: 'Sainte Brigitte de Suède', en: 'Saint Bridget of Sweden' },
    feastDay: { fr: '23 juillet', en: 'July 23' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Brigitte de Suède (1303-1373) était une mystique, fondatrice de l\'ordre des Brigittines.',
      en: 'Saint Bridget of Sweden (1303-1373) was a mystic, founder of the Bridgettine order.'
    }
  },
  'bruno': {
    saint: { fr: 'Saint Bruno', en: 'Saint Bruno' },
    feastDay: { fr: '6 octobre', en: 'October 6' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Bruno (1030-1101) est le fondateur de l\'ordre des Chartreux.',
      en: 'Saint Bruno (1030-1101) is the founder of the Carthusian order.'
    }
  },
  // C
  'camille': {
    saint: { fr: 'Saint Camille de Lellis', en: 'Saint Camillus de Lellis' },
    feastDay: { fr: '14 juillet', en: 'July 14' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Camille de Lellis (1550-1614) est le fondateur des Camilliens, patron des infirmiers.',
      en: 'Saint Camillus de Lellis (1550-1614) is the founder of the Camillians, patron saint of nurses.'
    }
  },
  'caroline': {
    saint: { fr: 'Sainte Caroline', en: 'Saint Caroline' },
    feastDay: { fr: '17 juillet', en: 'July 17' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Bienheureuse Caroline Gerhardinger était une religieuse bavaroise du XIXe siècle.',
      en: 'Blessed Caroline Gerhardinger was a Bavarian nun of the 19th century.'
    }
  },
  'catherine': {
    saint: { fr: 'Sainte Catherine d\'Alexandrie', en: 'Saint Catherine of Alexandria' },
    feastDay: { fr: '25 novembre', en: 'November 25' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Sainte Catherine d\'Alexandrie était une vierge et martyre du IVe siècle, patronne des philosophes.',
      en: 'Saint Catherine of Alexandria was a virgin and martyr of the 4th century, patron saint of philosophers.'
    }
  },
  'cecile': {
    saint: { fr: 'Sainte Cécile', en: 'Saint Cecilia' },
    feastDay: { fr: '22 novembre', en: 'November 22' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Cécile était une vierge et martyre romaine, patronne des musiciens.',
      en: 'Saint Cecilia was a Roman virgin and martyr, patron saint of musicians.'
    }
  },
  'celeste': {
    saint: { fr: 'Saint Célestin V', en: 'Saint Celestine V' },
    feastDay: { fr: '19 mai', en: 'May 19' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Célestin V était un pape ermite du XIIIe siècle qui abdiqua pour retourner à la vie contemplative.',
      en: 'Saint Celestine V was a hermit pope of the 13th century who abdicated to return to contemplative life.'
    }
  },
  'charles': {
    saint: { fr: 'Saint Charles Borromée', en: 'Saint Charles Borromeo' },
    feastDay: { fr: '4 novembre', en: 'November 4' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Charles Borromée (1538-1584) était cardinal et archevêque de Milan, réformateur de l\'Église.',
      en: 'Saint Charles Borromeo (1538-1584) was a cardinal and archbishop of Milan, reformer of the Church.'
    }
  },
  'charlotte': {
    saint: { fr: 'Bienheureuse Charlotte', en: 'Blessed Charlotte' },
    feastDay: { fr: '17 juillet', en: 'July 17' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Bienheureuse Charlotte était l\'une des Carmélites de Compiègne, martyrisée pendant la Révolution.',
      en: 'Blessed Charlotte was one of the Carmelites of Compiègne, martyred during the Revolution.'
    }
  },
  'chloe': {
    saint: { fr: 'Sainte Chloé', en: 'Saint Chloe' },
    feastDay: { fr: '13 février', en: 'February 13' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Chloé est mentionnée par Saint Paul dans ses lettres. Elle était une chrétienne de Corinthe.',
      en: 'Saint Chloe is mentioned by Saint Paul in his letters. She was a Christian from Corinth.'
    }
  },
  'christiane': {
    saint: { fr: 'Sainte Christiane', en: 'Saint Christiana' },
    feastDay: { fr: '15 décembre', en: 'December 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Christiane de Géorgie évangélisa la Géorgie au IVe siècle.',
      en: 'Saint Christiana of Georgia evangelized Georgia in the 4th century.'
    }
  },
  'christian': {
    saint: { fr: 'Saint Christian', en: 'Saint Christian' },
    feastDay: { fr: '12 novembre', en: 'November 12' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Christian était un évêque irlandais missionnaire en Irlande au VIIe siècle.',
      en: 'Saint Christian was an Irish bishop missionary in Ireland in the 7th century.'
    }
  },
  'christophe': {
    saint: { fr: 'Saint Christophe', en: 'Saint Christopher' },
    feastDay: { fr: '21 août', en: 'August 21' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Christophe est le patron des voyageurs. Selon la légende, il porta l\'enfant Jésus sur ses épaules.',
      en: 'Saint Christopher is the patron saint of travelers. According to legend, he carried the child Jesus on his shoulders.'
    }
  },
  'claire': {
    saint: { fr: 'Sainte Claire d\'Assise', en: 'Saint Clare of Assisi' },
    feastDay: { fr: '11 août', en: 'August 11' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Claire d\'Assise (1194-1253) était une disciple de Saint François et fondatrice des Clarisses.',
      en: 'Saint Clare of Assisi (1194-1253) was a disciple of Saint Francis and founder of the Poor Clares.'
    }
  },
  'claude': {
    saint: { fr: 'Saint Claude', en: 'Saint Claude' },
    feastDay: { fr: '6 juin', en: 'June 6' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Claude était un évêque de Besançon au VIIe siècle, vénéré dans le Jura.',
      en: 'Saint Claude was a bishop of Besançon in the 7th century, venerated in the Jura.'
    }
  },
  'clemence': {
    saint: { fr: 'Sainte Clémence', en: 'Saint Clemence' },
    feastDay: { fr: '21 mars', en: 'March 21' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Clémence d\'Hohenberg était une abbesse du XIIe siècle en Allemagne.',
      en: 'Saint Clemence of Hohenberg was a 12th century abbess in Germany.'
    }
  },
  'clement': {
    saint: { fr: 'Saint Clément', en: 'Saint Clement' },
    feastDay: { fr: '23 novembre', en: 'November 23' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Clément Ier fut le troisième pape après Saint Pierre, martyrisé vers l\'an 100.',
      en: 'Saint Clement I was the third pope after Saint Peter, martyred around the year 100.'
    }
  },
  'colette': {
    saint: { fr: 'Sainte Colette de Corbie', en: 'Saint Colette of Corbie' },
    feastDay: { fr: '6 mars', en: 'March 6' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Colette de Corbie (1381-1447) réforma l\'ordre des Clarisses.',
      en: 'Saint Colette of Corbie (1381-1447) reformed the Order of Poor Clares.'
    }
  },
  'corentin': {
    saint: { fr: 'Saint Corentin', en: 'Saint Corentin' },
    feastDay: { fr: '12 décembre', en: 'December 12' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Corentin fut le premier évêque de Quimper en Bretagne au Ve siècle.',
      en: 'Saint Corentin was the first bishop of Quimper in Brittany in the 5th century.'
    }
  },
  'cyrille': {
    saint: { fr: 'Saint Cyrille', en: 'Saint Cyril' },
    feastDay: { fr: '14 février', en: 'February 14' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Cyrille de Jérusalem était un évêque et Docteur de l\'Église du IVe siècle.',
      en: 'Saint Cyril of Jerusalem was a bishop and Doctor of the Church in the 4th century.'
    }
  },
  // D
  'damien': {
    saint: { fr: 'Saint Damien de Molokai', en: 'Saint Damien of Molokai' },
    feastDay: { fr: '10 mai', en: 'May 10' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Damien de Molokai (1840-1889) était un prêtre belge qui consacra sa vie aux lépreux.',
      en: 'Saint Damien of Molokai (1840-1889) was a Belgian priest who devoted his life to lepers.'
    }
  },
  'daniel': {
    saint: { fr: 'Saint Daniel', en: 'Saint Daniel' },
    feastDay: { fr: '11 décembre', en: 'December 11' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Daniel était un prophète de l\'Ancien Testament, célèbre pour avoir survécu à la fosse aux lions.',
      en: 'Saint Daniel was an Old Testament prophet, famous for surviving the lions\' den.'
    }
  },
  'david': {
    saint: { fr: 'Saint David', en: 'Saint David' },
    feastDay: { fr: '1er mars', en: 'March 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint David de Galles (vers 500-589) était un évêque et le patron du Pays de Galles.',
      en: 'Saint David of Wales (c. 500-589) was a bishop and the patron saint of Wales.'
    }
  },
  'denis': {
    saint: { fr: 'Saint Denis', en: 'Saint Denis' },
    feastDay: { fr: '9 octobre', en: 'October 9' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Denis fut le premier évêque de Paris au IIIe siècle et un martyr.',
      en: 'Saint Denis was the first bishop of Paris in the 3rd century and a martyr.'
    }
  },
  'didier': {
    saint: { fr: 'Saint Didier', en: 'Saint Desiderius' },
    feastDay: { fr: '23 mai', en: 'May 23' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Didier de Vienne était un évêque du VIe siècle, martyrisé par la reine Brunehaut.',
      en: 'Saint Desiderius of Vienne was a 6th century bishop, martyred by Queen Brunhild.'
    }
  },
  'dominique': {
    saint: { fr: 'Saint Dominique', en: 'Saint Dominic' },
    feastDay: { fr: '8 août', en: 'August 8' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Dominique (1170-1221) est le fondateur de l\'Ordre des Prêcheurs (Dominicains).',
      en: 'Saint Dominic (1170-1221) is the founder of the Order of Preachers (Dominicans).'
    }
  },
  // E
  'edith': {
    saint: { fr: 'Sainte Édith Stein', en: 'Saint Edith Stein' },
    feastDay: { fr: '9 août', en: 'August 9' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Édith Stein (1891-1942) était une philosophe juive convertie, carmélite, morte à Auschwitz.',
      en: 'Saint Edith Stein (1891-1942) was a converted Jewish philosopher, Carmelite, who died at Auschwitz.'
    }
  },
  'edouard': {
    saint: { fr: 'Saint Édouard le Confesseur', en: 'Saint Edward the Confessor' },
    feastDay: { fr: '13 octobre', en: 'October 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Édouard le Confesseur (1003-1066) fut roi d\'Angleterre, connu pour sa piété.',
      en: 'Saint Edward the Confessor (1003-1066) was King of England, known for his piety.'
    }
  },
  'eleonore': {
    saint: { fr: 'Sainte Éléonore', en: 'Saint Eleanor' },
    feastDay: { fr: '25 juin', en: 'June 25' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Éléonore d\'Aragon était une reine portugaise du XVe siècle, connue pour sa charité.',
      en: 'Saint Eleanor of Aragon was a Portuguese queen of the 15th century, known for her charity.'
    }
  },
  'eliane': {
    saint: { fr: 'Sainte Éliane', en: 'Saint Eliana' },
    feastDay: { fr: '4 juillet', en: 'July 4' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Éliane était une martyre romaine du IIe siècle.',
      en: 'Saint Eliana was a Roman martyr of the 2nd century.'
    }
  },
  'elisabeth': {
    saint: { fr: 'Sainte Élisabeth de Hongrie', en: 'Saint Elizabeth of Hungary' },
    feastDay: { fr: '17 novembre', en: 'November 17' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Élisabeth de Hongrie (1207-1231) était une princesse connue pour sa charité envers les pauvres.',
      en: 'Saint Elizabeth of Hungary (1207-1231) was a princess known for her charity to the poor.'
    }
  },
  'elodie': {
    saint: { fr: 'Sainte Élodie', en: 'Saint Alodia' },
    feastDay: { fr: '22 octobre', en: 'October 22' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Élodie (Alodia) était une vierge et martyre espagnole du IXe siècle.',
      en: 'Saint Alodia was a Spanish virgin and martyr of the 9th century.'
    }
  },
  'eloi': {
    saint: { fr: 'Saint Éloi', en: 'Saint Eligius' },
    feastDay: { fr: '1er décembre', en: 'December 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Éloi (588-660) était un orfèvre devenu évêque de Noyon, patron des orfèvres.',
      en: 'Saint Eligius (588-660) was a goldsmith who became Bishop of Noyon, patron saint of goldsmiths.'
    }
  },
  'emile': {
    saint: { fr: 'Saint Émile', en: 'Saint Emile' },
    feastDay: { fr: '22 mai', en: 'May 22' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Émile de Carthage était un martyr africain du IIIe siècle.',
      en: 'Saint Emile of Carthage was an African martyr of the 3rd century.'
    }
  },
  'emma': {
    saint: { fr: 'Sainte Emma de Gurk', en: 'Saint Emma of Gurk' },
    feastDay: { fr: '29 juin', en: 'June 29' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Emma de Gurk (vers 980-1045) était une comtesse autrichienne connue pour sa charité.',
      en: 'Saint Emma of Gurk (c. 980-1045) was an Austrian countess known for her charity.'
    }
  },
  'emmanuel': {
    saint: { fr: 'Saint Emmanuel', en: 'Saint Emmanuel' },
    feastDay: { fr: '26 mars', en: 'March 26' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Emmanuel était l\'un des martyrs de Cordoue du IXe siècle.',
      en: 'Saint Emmanuel was one of the martyrs of Cordoba in the 9th century.'
    }
  },
  'eric': {
    saint: { fr: 'Saint Éric de Suède', en: 'Saint Eric of Sweden' },
    feastDay: { fr: '18 mai', en: 'May 18' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Éric IX de Suède (1120-1160) fut un roi suédois connu pour sa piété et sa charité.',
      en: 'Saint Eric IX of Sweden (1120-1160) was a Swedish king known for his piety and charity.'
    }
  },
  'estelle': {
    saint: { fr: 'Sainte Estelle', en: 'Saint Estelle' },
    feastDay: { fr: '11 mai', en: 'May 11' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Estelle de Saintes était une vierge et martyre du IIIe siècle en Gaule.',
      en: 'Saint Estelle of Saintes was a virgin and martyr of the 3rd century in Gaul.'
    }
  },
  'etienne': {
    saint: { fr: 'Saint Étienne', en: 'Saint Stephen' },
    feastDay: { fr: '26 décembre', en: 'December 26' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Étienne fut le premier martyr chrétien, lapidé à mort pour sa foi.',
      en: 'Saint Stephen was the first Christian martyr, stoned to death for his faith.'
    }
  },
  'eugene': {
    saint: { fr: 'Saint Eugène', en: 'Saint Eugene' },
    feastDay: { fr: '2 juin', en: 'June 2' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Eugène de Mazenod (1782-1861) était un évêque français, fondateur des Oblats de Marie Immaculée.',
      en: 'Saint Eugene de Mazenod (1782-1861) was a French bishop, founder of the Oblates of Mary Immaculate.'
    }
  },
  'eva': {
    saint: { fr: 'Sainte Ève', en: 'Saint Eve' },
    feastDay: { fr: '6 septembre', en: 'September 6' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Ève était une recluse de Liège au XIIIe siècle, connue pour sa vie mystique.',
      en: 'Saint Eve was a recluse of Liège in the 13th century, known for her mystical life.'
    }
  },
  // F
  'fabien': {
    saint: { fr: 'Saint Fabien', en: 'Saint Fabian' },
    feastDay: { fr: '20 janvier', en: 'January 20' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Fabien fut pape de 236 à 250, martyrisé sous l\'empereur Dèce.',
      en: 'Saint Fabian was pope from 236 to 250, martyred under Emperor Decius.'
    }
  },
  'fabrice': {
    saint: { fr: 'Saint Fabrice', en: 'Saint Fabricius' },
    feastDay: { fr: '22 août', en: 'August 22' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Fabrice de Tolède était un martyr espagnol du IIIe siècle.',
      en: 'Saint Fabricius of Toledo was a Spanish martyr of the 3rd century.'
    }
  },
  'felix': {
    saint: { fr: 'Saint Félix', en: 'Saint Felix' },
    feastDay: { fr: '14 janvier', en: 'January 14' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Félix de Nole était un prêtre du IIIe siècle miraculeusement protégé.',
      en: 'Saint Felix of Nola was a 3rd century priest miraculously protected.'
    }
  },
  'florent': {
    saint: { fr: 'Saint Florent', en: 'Saint Florentius' },
    feastDay: { fr: '4 juillet', en: 'July 4' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Florent de Strasbourg était un évêque du VIIe siècle.',
      en: 'Saint Florentius of Strasbourg was a 7th century bishop.'
    }
  },
  'florence': {
    saint: { fr: 'Sainte Florence', en: 'Saint Florence' },
    feastDay: { fr: '1er décembre', en: 'December 1' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Florence de Poitiers était une vierge et martyre du IVe siècle.',
      en: 'Saint Florence of Poitiers was a virgin and martyr of the 4th century.'
    }
  },
  'francois': {
    saint: { fr: 'Saint François d\'Assise', en: 'Saint Francis of Assisi' },
    feastDay: { fr: '4 octobre', en: 'October 4' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint François d\'Assise (1181-1226) est le fondateur de l\'ordre franciscain, patron de l\'écologie.',
      en: 'Saint Francis of Assisi (1181-1226) is the founder of the Franciscan order, patron saint of ecology.'
    }
  },
  'francoise': {
    saint: { fr: 'Sainte Françoise Romaine', en: 'Saint Frances of Rome' },
    feastDay: { fr: '9 mars', en: 'March 9' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Françoise Romaine (1384-1440) était une mystique romaine, patronne des automobilistes.',
      en: 'Saint Frances of Rome (1384-1440) was a Roman mystic, patron saint of motorists.'
    }
  },
  'frederic': {
    saint: { fr: 'Saint Frédéric', en: 'Saint Frederick' },
    feastDay: { fr: '18 juillet', en: 'July 18' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Frédéric d\'Utrecht était un évêque du IXe siècle, martyrisé.',
      en: 'Saint Frederick of Utrecht was a 9th century bishop, martyred.'
    }
  },
  // G
  'gabriel': {
    saint: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    feastDay: { fr: '29 septembre', en: 'September 29' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'L\'archange Gabriel est le messager de Dieu, qui annonça à Marie la naissance de Jésus.',
      en: 'The Archangel Gabriel is God\'s messenger, who announced to Mary the birth of Jesus.'
    }
  },
  'gaetan': {
    saint: { fr: 'Saint Gaétan de Thiene', en: 'Saint Cajetan' },
    feastDay: { fr: '7 août', en: 'August 7' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Gaétan de Thiene (1480-1547) était un prêtre italien, fondateur des Théatins.',
      en: 'Saint Cajetan (1480-1547) was an Italian priest, founder of the Theatines.'
    }
  },
  'genevieve': {
    saint: { fr: 'Sainte Geneviève', en: 'Saint Genevieve' },
    feastDay: { fr: '3 janvier', en: 'January 3' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Geneviève (423-512) est la patronne de Paris, qui protégea la ville contre les Huns.',
      en: 'Saint Genevieve (423-512) is the patron saint of Paris, who protected the city against the Huns.'
    }
  },
  'georges': {
    saint: { fr: 'Saint Georges', en: 'Saint George' },
    feastDay: { fr: '23 avril', en: 'April 23' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Georges était un soldat romain martyrisé, célèbre pour la légende du dragon.',
      en: 'Saint George was a martyred Roman soldier, famous for the legend of the dragon.'
    }
  },
  'gerard': {
    saint: { fr: 'Saint Gérard Majella', en: 'Saint Gerard Majella' },
    feastDay: { fr: '16 octobre', en: 'October 16' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Gérard Majella (1726-1755) était un religieux rédemptoriste, patron des futures mères.',
      en: 'Saint Gerard Majella (1726-1755) was a Redemptorist religious, patron saint of expectant mothers.'
    }
  },
  'germain': {
    saint: { fr: 'Saint Germain', en: 'Saint Germain' },
    feastDay: { fr: '28 mai', en: 'May 28' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Germain de Paris (496-576) était un évêque de Paris, fondateur de l\'abbaye de Saint-Germain-des-Prés.',
      en: 'Saint Germain of Paris (496-576) was a bishop of Paris, founder of the Abbey of Saint-Germain-des-Prés.'
    }
  },
  'gilbert': {
    saint: { fr: 'Saint Gilbert', en: 'Saint Gilbert' },
    feastDay: { fr: '4 février', en: 'February 4' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Gilbert de Sempringham (1083-1189) était un prêtre anglais fondateur des Gilbertins.',
      en: 'Saint Gilbert of Sempringham (1083-1189) was an English priest founder of the Gilbertines.'
    }
  },
  'gilles': {
    saint: { fr: 'Saint Gilles', en: 'Saint Giles' },
    feastDay: { fr: '1er septembre', en: 'September 1' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Gilles l\'Ermite était un ermite athénien du VIIe siècle, vénéré en Provence.',
      en: 'Saint Giles the Hermit was an Athenian hermit of the 7th century, venerated in Provence.'
    }
  },
  'gregoire': {
    saint: { fr: 'Saint Grégoire le Grand', en: 'Saint Gregory the Great' },
    feastDay: { fr: '3 septembre', en: 'September 3' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Grégoire le Grand (540-604) fut pape et Docteur de l\'Église, réformateur de la liturgie.',
      en: 'Saint Gregory the Great (540-604) was pope and Doctor of the Church, reformer of the liturgy.'
    }
  },
  'guillaume': {
    saint: { fr: 'Saint Guillaume', en: 'Saint William' },
    feastDay: { fr: '10 janvier', en: 'January 10' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Guillaume de Bourges (1155-1209) était un archevêque célèbre pour sa sainteté.',
      en: 'Saint William of Bourges (1155-1209) was an archbishop famous for his holiness.'
    }
  },
  'gustave': {
    saint: { fr: 'Saint Gustave', en: 'Saint Gustav' },
    feastDay: { fr: '3 août', en: 'August 3' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Gustave était un moine suédois du XIIe siècle.',
      en: 'Saint Gustav was a Swedish monk of the 12th century.'
    }
  },
  'guy': {
    saint: { fr: 'Saint Guy', en: 'Saint Guy' },
    feastDay: { fr: '12 septembre', en: 'September 12' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Guy d\'Anderlecht était un pèlerin belge du XIe siècle, patron des sacristains.',
      en: 'Saint Guy of Anderlecht was a Belgian pilgrim of the 11th century, patron saint of sacristans.'
    }
  },
  // H
  'helene': {
    saint: { fr: 'Sainte Hélène', en: 'Saint Helena' },
    feastDay: { fr: '18 août', en: 'August 18' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Hélène (vers 250-330) était la mère de l\'empereur Constantin, qui découvrit la Vraie Croix.',
      en: 'Saint Helena (c. 250-330) was the mother of Emperor Constantine, who discovered the True Cross.'
    }
  },
  'henri': {
    saint: { fr: 'Saint Henri', en: 'Saint Henry' },
    feastDay: { fr: '13 juillet', en: 'July 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Henri II (973-1024) fut empereur du Saint-Empire, connu pour sa piété.',
      en: 'Saint Henry II (973-1024) was Holy Roman Emperor, known for his piety.'
    }
  },
  'herve': {
    saint: { fr: 'Saint Hervé', en: 'Saint Harvey' },
    feastDay: { fr: '17 juin', en: 'June 17' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Hervé de Bretagne était un abbé et barde aveugle du VIe siècle.',
      en: 'Saint Harvey of Brittany was a blind abbot and bard of the 6th century.'
    }
  },
  'hilaire': {
    saint: { fr: 'Saint Hilaire', en: 'Saint Hilary' },
    feastDay: { fr: '13 janvier', en: 'January 13' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Hilaire de Poitiers (315-367) était un évêque et Docteur de l\'Église.',
      en: 'Saint Hilary of Poitiers (315-367) was a bishop and Doctor of the Church.'
    }
  },
  'hippolyte': {
    saint: { fr: 'Saint Hippolyte', en: 'Saint Hippolytus' },
    feastDay: { fr: '13 août', en: 'August 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Hippolyte de Rome était un prêtre et théologien du IIIe siècle.',
      en: 'Saint Hippolytus of Rome was a 3rd century priest and theologian.'
    }
  },
  'hubert': {
    saint: { fr: 'Saint Hubert', en: 'Saint Hubert' },
    feastDay: { fr: '3 novembre', en: 'November 3' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Hubert (656-727) était évêque de Liège, patron des chasseurs.',
      en: 'Saint Hubert (656-727) was Bishop of Liège, patron saint of hunters.'
    }
  },
  'hugo': {
    saint: { fr: 'Saint Hugues', en: 'Saint Hugh' },
    feastDay: { fr: '1er avril', en: 'April 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Hugues de Grenoble (1052-1132) était évêque de Grenoble qui accueillit les Chartreux.',
      en: 'Saint Hugh of Grenoble (1052-1132) was Bishop of Grenoble who welcomed the Carthusians.'
    }
  },
  // I
  'ignace': {
    saint: { fr: 'Saint Ignace de Loyola', en: 'Saint Ignatius of Loyola' },
    feastDay: { fr: '31 juillet', en: 'July 31' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Ignace de Loyola (1491-1556) est le fondateur de la Compagnie de Jésus (Jésuites).',
      en: 'Saint Ignatius of Loyola (1491-1556) is the founder of the Society of Jesus (Jesuits).'
    }
  },
  'irene': {
    saint: { fr: 'Sainte Irène', en: 'Saint Irene' },
    feastDay: { fr: '5 avril', en: 'April 5' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Irène de Thessalonique était une vierge et martyre du IVe siècle.',
      en: 'Saint Irene of Thessalonica was a virgin and martyr of the 4th century.'
    }
  },
  'isabelle': {
    saint: { fr: 'Sainte Isabelle de France', en: 'Saint Isabella of France' },
    feastDay: { fr: '22 février', en: 'February 22' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Isabelle de France (1225-1270) était une princesse française, sœur de Saint Louis.',
      en: 'Saint Isabella of France (1225-1270) was a French princess, sister of Saint Louis.'
    }
  },
  // J
  'jacques': {
    saint: { fr: 'Saint Jacques le Majeur', en: 'Saint James the Greater' },
    feastDay: { fr: '25 juillet', en: 'July 25' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Jacques le Majeur était l\'un des douze apôtres. Son tombeau à Compostelle est un lieu de pèlerinage.',
      en: 'Saint James the Greater was one of the twelve apostles. His tomb in Compostela is a pilgrimage site.'
    }
  },
  'jean': {
    saint: { fr: 'Saint Jean l\'Évangéliste', en: 'Saint John the Evangelist' },
    feastDay: { fr: '27 décembre', en: 'December 27' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Jean l\'Évangéliste était l\'apôtre bien-aimé de Jésus et l\'auteur de l\'Évangile selon Jean.',
      en: 'Saint John the Evangelist was the beloved apostle of Jesus and the author of the Gospel of John.'
    }
  },
  'jeanne': {
    saint: { fr: 'Sainte Jeanne d\'Arc', en: 'Saint Joan of Arc' },
    feastDay: { fr: '30 mai', en: 'May 30' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Sainte Jeanne d\'Arc (1412-1431) est l\'héroïne nationale française, brûlée vive puis canonisée.',
      en: 'Saint Joan of Arc (1412-1431) is the French national heroine, burned alive then canonized.'
    }
  },
  'jerome': {
    saint: { fr: 'Saint Jérôme', en: 'Saint Jerome' },
    feastDay: { fr: '30 septembre', en: 'September 30' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Jérôme (347-420) est le traducteur de la Bible en latin (Vulgate), Docteur de l\'Église.',
      en: 'Saint Jerome (347-420) is the translator of the Bible into Latin (Vulgate), Doctor of the Church.'
    }
  },
  'joachim': {
    saint: { fr: 'Saint Joachim', en: 'Saint Joachim' },
    feastDay: { fr: '26 juillet', en: 'July 26' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Joachim était le père de la Vierge Marie et grand-père de Jésus.',
      en: 'Saint Joachim was the father of the Virgin Mary and grandfather of Jesus.'
    }
  },
  'joel': {
    saint: { fr: 'Saint Joël', en: 'Saint Joel' },
    feastDay: { fr: '13 juillet', en: 'July 13' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Joël était un prophète de l\'Ancien Testament.',
      en: 'Saint Joel was a prophet of the Old Testament.'
    }
  },
  'joseph': {
    saint: { fr: 'Saint Joseph', en: 'Saint Joseph' },
    feastDay: { fr: '19 mars', en: 'March 19' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Joseph était l\'époux de la Vierge Marie et le père adoptif de Jésus. Patron des travailleurs.',
      en: 'Saint Joseph was the husband of the Virgin Mary and the foster father of Jesus. Patron of workers.'
    }
  },
  'judith': {
    saint: { fr: 'Sainte Judith', en: 'Saint Judith' },
    feastDay: { fr: '6 mai', en: 'May 6' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Judith de Bavière était une duchesse du IXe siècle connue pour sa piété.',
      en: 'Saint Judith of Bavaria was a 9th century duchess known for her piety.'
    }
  },
  'jules': {
    saint: { fr: 'Saint Jules Ier', en: 'Saint Julius I' },
    feastDay: { fr: '12 avril', en: 'April 12' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Jules Ier fut pape de 337 à 352, défenseur de Saint Athanase.',
      en: 'Saint Julius I was pope from 337 to 352, defender of Saint Athanasius.'
    }
  },
  'julie': {
    saint: { fr: 'Sainte Julie', en: 'Saint Julia' },
    feastDay: { fr: '22 mai', en: 'May 22' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Sainte Julie de Corse fut une vierge et martyre du Ve siècle.',
      en: 'Saint Julia of Corsica was a virgin and martyr of the 5th century.'
    }
  },
  'julien': {
    saint: { fr: 'Saint Julien l\'Hospitalier', en: 'Saint Julian the Hospitaller' },
    feastDay: { fr: '12 février', en: 'February 12' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Julien l\'Hospitalier est le patron des voyageurs et des hôteliers.',
      en: 'Saint Julian the Hospitaller is the patron saint of travelers and innkeepers.'
    }
  },
  'justine': {
    saint: { fr: 'Sainte Justine', en: 'Saint Justina' },
    feastDay: { fr: '7 octobre', en: 'October 7' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Justine de Padoue était une vierge et martyre du IVe siècle.',
      en: 'Saint Justina of Padua was a virgin and martyr of the 4th century.'
    }
  },
  // K
  'karine': {
    saint: { fr: 'Sainte Karine', en: 'Saint Karina' },
    feastDay: { fr: '7 novembre', en: 'November 7' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Karine était une martyre arménienne du IVe siècle.',
      en: 'Saint Karina was an Armenian martyr of the 4th century.'
    }
  },
  'kevin': {
    saint: { fr: 'Saint Kévin', en: 'Saint Kevin' },
    feastDay: { fr: '3 juin', en: 'June 3' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Kévin de Glendalough (498-618) était un ermite irlandais fondateur d\'un monastère.',
      en: 'Saint Kevin of Glendalough (498-618) was an Irish hermit founder of a monastery.'
    }
  },
  // L
  'laure': {
    saint: { fr: 'Sainte Laure', en: 'Saint Laura' },
    feastDay: { fr: '10 août', en: 'August 10' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Laure de Cordoue était une martyre du IXe siècle en Espagne.',
      en: 'Saint Laura of Cordoba was a 9th century martyr in Spain.'
    }
  },
  'laurent': {
    saint: { fr: 'Saint Laurent', en: 'Saint Lawrence' },
    feastDay: { fr: '10 août', en: 'August 10' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Laurent de Rome était un diacre martyrisé sur un gril au IIIe siècle.',
      en: 'Saint Lawrence of Rome was a deacon martyred on a gridiron in the 3rd century.'
    }
  },
  'lea': {
    saint: { fr: 'Sainte Léa', en: 'Saint Lea' },
    feastDay: { fr: '22 mars', en: 'March 22' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Léa de Rome (IVe siècle) était une veuve noble qui fonda un monastère.',
      en: 'Saint Lea of Rome (4th century) was a noble widow who founded a monastery.'
    }
  },
  'leon': {
    saint: { fr: 'Saint Léon le Grand', en: 'Saint Leo the Great' },
    feastDay: { fr: '10 novembre', en: 'November 10' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Léon le Grand (400-461) fut pape et Docteur de l\'Église, il arrêta Attila.',
      en: 'Saint Leo the Great (400-461) was pope and Doctor of the Church, he stopped Attila.'
    }
  },
  'leonard': {
    saint: { fr: 'Saint Léonard', en: 'Saint Leonard' },
    feastDay: { fr: '6 novembre', en: 'November 6' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Léonard de Noblat était un ermite du VIe siècle, patron des prisonniers.',
      en: 'Saint Leonard of Noblat was a 6th century hermit, patron saint of prisoners.'
    }
  },
  'louis': {
    saint: { fr: 'Saint Louis', en: 'Saint Louis' },
    feastDay: { fr: '25 août', en: 'August 25' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Louis IX (1214-1270) fut roi de France, célèbre pour sa piété et sa justice.',
      en: 'Saint Louis IX (1214-1270) was King of France, famous for his piety and justice.'
    }
  },
  'louise': {
    saint: { fr: 'Sainte Louise de Marillac', en: 'Saint Louise de Marillac' },
    feastDay: { fr: '15 mars', en: 'March 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Louise de Marillac (1591-1660) co-fonda les Filles de la Charité avec Saint Vincent de Paul.',
      en: 'Saint Louise de Marillac (1591-1660) co-founded the Daughters of Charity with Saint Vincent de Paul.'
    }
  },
  'luc': {
    saint: { fr: 'Saint Luc', en: 'Saint Luke' },
    feastDay: { fr: '18 octobre', en: 'October 18' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Luc était un médecin et l\'auteur de l\'Évangile selon Luc. Patron des médecins.',
      en: 'Saint Luke was a physician and author of the Gospel of Luke. Patron saint of physicians.'
    }
  },
  'lucas': {
    saint: { fr: 'Saint Luc', en: 'Saint Luke' },
    feastDay: { fr: '18 octobre', en: 'October 18' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Luc était un médecin et l\'auteur de l\'Évangile selon Luc et des Actes des Apôtres.',
      en: 'Saint Luke was a physician and the author of the Gospel of Luke and the Acts of the Apostles.'
    }
  },
  'lucie': {
    saint: { fr: 'Sainte Lucie', en: 'Saint Lucy' },
    feastDay: { fr: '13 décembre', en: 'December 13' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Sainte Lucie de Syracuse (283-304) était une vierge et martyre, patronne de ceux qui ont des problèmes de vue.',
      en: 'Saint Lucy of Syracuse (283-304) was a virgin and martyr, patron saint of those with eye problems.'
    }
  },
  'lucien': {
    saint: { fr: 'Saint Lucien', en: 'Saint Lucian' },
    feastDay: { fr: '8 janvier', en: 'January 8' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Lucien de Beauvais était un évangélisateur du IIIe siècle, martyrisé en Gaule.',
      en: 'Saint Lucian of Beauvais was a 3rd century evangelist, martyred in Gaul.'
    }
  },
  // M
  'madeleine': {
    saint: { fr: 'Sainte Marie-Madeleine', en: 'Saint Mary Magdalene' },
    feastDay: { fr: '22 juillet', en: 'July 22' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Marie-Madeleine fut le premier témoin de la Résurrection du Christ.',
      en: 'Saint Mary Magdalene was the first witness to the Resurrection of Christ.'
    }
  },
  'manon': {
    saint: { fr: 'Sainte Marie', en: 'Saint Mary' },
    feastDay: { fr: '15 août', en: 'August 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Manon est un dérivé de Marie. La Vierge Marie est la mère de Jésus-Christ.',
      en: 'Manon is a derivative of Mary. The Virgin Mary is the mother of Jesus Christ.'
    }
  },
  'marc': {
    saint: { fr: 'Saint Marc', en: 'Saint Mark' },
    feastDay: { fr: '25 avril', en: 'April 25' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Marc l\'Évangéliste est l\'auteur du deuxième Évangile, patron de Venise.',
      en: 'Saint Mark the Evangelist is the author of the second Gospel, patron saint of Venice.'
    }
  },
  'marcel': {
    saint: { fr: 'Saint Marcel', en: 'Saint Marcellus' },
    feastDay: { fr: '16 janvier', en: 'January 16' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Marcel Ier fut pape de 308 à 309. Il réorganisa l\'Église après les persécutions de Dioclétien.',
      en: 'Saint Marcellus I was pope from 308 to 309. He reorganized the Church after Diocletian\'s persecutions.'
    }
  },
  'marguerite': {
    saint: { fr: 'Sainte Marguerite-Marie Alacoque', en: 'Saint Margaret Mary Alacoque' },
    feastDay: { fr: '16 octobre', en: 'October 16' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Marguerite-Marie Alacoque (1647-1690) était une religieuse visionnaire de la dévotion au Sacré-Cœur.',
      en: 'Saint Margaret Mary Alacoque (1647-1690) was a visionary nun of the devotion to the Sacred Heart.'
    }
  },
  'marie': {
    saint: { fr: 'Sainte Marie, Vierge Marie', en: 'Saint Mary, Virgin Mary' },
    feastDay: { fr: '15 août', en: 'August 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'La Vierge Marie est la mère de Jésus-Christ. Elle est vénérée comme la plus grande des saintes.',
      en: 'The Virgin Mary is the mother of Jesus Christ. She is venerated as the greatest of saints.'
    }
  },
  'marine': {
    saint: { fr: 'Sainte Marine', en: 'Saint Marina' },
    feastDay: { fr: '20 juillet', en: 'July 20' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Marine d\'Antioche était une vierge et martyre du IIIe siècle.',
      en: 'Saint Marina of Antioch was a virgin and martyr of the 3rd century.'
    }
  },
  'marius': {
    saint: { fr: 'Saint Marius', en: 'Saint Marius' },
    feastDay: { fr: '19 janvier', en: 'January 19' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Marius était un noble perse martyrisé à Rome avec sa famille au IIIe siècle.',
      en: 'Saint Marius was a Persian noble martyred in Rome with his family in the 3rd century.'
    }
  },
  'martin': {
    saint: { fr: 'Saint Martin de Tours', en: 'Saint Martin of Tours' },
    feastDay: { fr: '11 novembre', en: 'November 11' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Martin de Tours (316-397) était un soldat romain devenu évêque, qui partagea son manteau avec un pauvre.',
      en: 'Saint Martin of Tours (316-397) was a Roman soldier who became a bishop, who shared his cloak with a poor man.'
    }
  },
  'mathieu': {
    saint: { fr: 'Saint Matthieu', en: 'Saint Matthew' },
    feastDay: { fr: '21 septembre', en: 'September 21' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Matthieu était un collecteur d\'impôts devenu apôtre et auteur du premier Évangile.',
      en: 'Saint Matthew was a tax collector who became an apostle and the author of the first Gospel.'
    }
  },
  'mathilde': {
    saint: { fr: 'Sainte Mathilde', en: 'Saint Matilda' },
    feastDay: { fr: '14 mars', en: 'March 14' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Mathilde de Ringelheim (895-968) était une reine germanique connue pour sa charité.',
      en: 'Saint Matilda of Ringelheim (895-968) was a German queen known for her charity.'
    }
  },
  'maurice': {
    saint: { fr: 'Saint Maurice', en: 'Saint Maurice' },
    feastDay: { fr: '22 septembre', en: 'September 22' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Maurice d\'Agaune était le chef de la légion thébaine, martyrisé au IIIe siècle.',
      en: 'Saint Maurice of Agaunum was the leader of the Theban Legion, martyred in the 3rd century.'
    }
  },
  'maxime': {
    saint: { fr: 'Saint Maxime', en: 'Saint Maximus' },
    feastDay: { fr: '14 avril', en: 'April 14' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Maxime le Confesseur (580-662) était un moine et théologien byzantin.',
      en: 'Saint Maximus the Confessor (580-662) was a Byzantine monk and theologian.'
    }
  },
  'michel': {
    saint: { fr: 'Archange Michel', en: 'Archangel Michael' },
    feastDay: { fr: '29 septembre', en: 'September 29' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'L\'archange Michel est le chef des armées célestes et le protecteur contre le mal.',
      en: 'The Archangel Michael is the leader of the heavenly armies and the protector against evil.'
    }
  },
  'monique': {
    saint: { fr: 'Sainte Monique', en: 'Saint Monica' },
    feastDay: { fr: '27 août', en: 'August 27' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Monique (331-387) était la mère de Saint Augustin, patronne des mères.',
      en: 'Saint Monica (331-387) was the mother of Saint Augustine, patron saint of mothers.'
    }
  },
  // N
  'nathalie': {
    saint: { fr: 'Sainte Nathalie', en: 'Saint Natalie' },
    feastDay: { fr: '27 juillet', en: 'July 27' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Nathalie de Nicomédie soutint son mari Adrien dans son martyre au IVe siècle.',
      en: 'Saint Natalie of Nicomedia supported her husband Adrian in his martyrdom in the 4th century.'
    }
  },
  'nicolas': {
    saint: { fr: 'Saint Nicolas', en: 'Saint Nicholas' },
    feastDay: { fr: '6 décembre', en: 'December 6' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Nicolas de Myre (270-343) était un évêque célèbre pour sa générosité, inspiration du Père Noël.',
      en: 'Saint Nicholas of Myra (270-343) was a bishop famous for his generosity, inspiration for Santa Claus.'
    }
  },
  'noel': {
    saint: { fr: 'Saint Noël', en: 'Saint Noel' },
    feastDay: { fr: '25 décembre', en: 'December 25' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Noël Chabanel était un missionnaire jésuite français martyrisé au Canada au XVIIe siècle.',
      en: 'Saint Noel Chabanel was a French Jesuit missionary martyred in Canada in the 17th century.'
    }
  },
  // O
  'olivier': {
    saint: { fr: 'Saint Olivier Plunkett', en: 'Saint Oliver Plunkett' },
    feastDay: { fr: '1er juillet', en: 'July 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Olivier Plunkett (1625-1681) était archevêque d\'Armagh, martyrisé pour sa foi.',
      en: 'Saint Oliver Plunkett (1625-1681) was Archbishop of Armagh, martyred for his faith.'
    }
  },
  'oscar': {
    saint: { fr: 'Saint Oscar', en: 'Saint Oscar' },
    feastDay: { fr: '3 février', en: 'February 3' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Oscar (Anschaire) fut l\'apôtre de la Scandinavie au IXe siècle.',
      en: 'Saint Oscar (Ansgar) was the apostle of Scandinavia in the 9th century.'
    }
  },
  // P
  'pascal': {
    saint: { fr: 'Saint Pascal Baylon', en: 'Saint Paschal Baylon' },
    feastDay: { fr: '17 mai', en: 'May 17' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Pascal Baylon (1540-1592) était un frère franciscain espagnol, patron des congrès eucharistiques.',
      en: 'Saint Paschal Baylon (1540-1592) was a Spanish Franciscan brother, patron saint of Eucharistic congresses.'
    }
  },
  'patrick': {
    saint: { fr: 'Saint Patrick', en: 'Saint Patrick' },
    feastDay: { fr: '17 mars', en: 'March 17' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Patrick (385-461) est l\'apôtre de l\'Irlande, célèbre pour avoir chassé les serpents.',
      en: 'Saint Patrick (385-461) is the apostle of Ireland, famous for driving out the snakes.'
    }
  },
  'paul': {
    saint: { fr: 'Saint Paul', en: 'Saint Paul' },
    feastDay: { fr: '29 juin', en: 'June 29' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Paul (vers 5-67) était d\'abord un persécuteur des chrétiens avant sa conversion sur le chemin de Damas.',
      en: 'Saint Paul (c. 5-67) was first a persecutor of Christians before his conversion on the road to Damascus.'
    }
  },
  'pauline': {
    saint: { fr: 'Sainte Pauline', en: 'Saint Pauline' },
    feastDay: { fr: '9 juillet', en: 'July 9' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Pauline du Cœur Agonisant de Jésus (1865-1942) était une religieuse brésilienne fondatrice.',
      en: 'Saint Pauline of the Agonizing Heart of Jesus (1865-1942) was a Brazilian founding religious.'
    }
  },
  'philippe': {
    saint: { fr: 'Saint Philippe', en: 'Saint Philip' },
    feastDay: { fr: '3 mai', en: 'May 3' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Philippe l\'Apôtre était l\'un des douze apôtres de Jésus.',
      en: 'Saint Philip the Apostle was one of the twelve apostles of Jesus.'
    }
  },
  'pierre': {
    saint: { fr: 'Saint Pierre', en: 'Saint Peter' },
    feastDay: { fr: '29 juin', en: 'June 29' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Pierre était le chef des apôtres et le premier pape. Jésus lui dit : "Tu es Pierre, et sur cette pierre je bâtirai mon Église".',
      en: 'Saint Peter was the leader of the apostles and the first pope. Jesus told him: "You are Peter, and on this rock I will build my Church".'
    }
  },
  // Q
  'quentin': {
    saint: { fr: 'Saint Quentin', en: 'Saint Quentin' },
    feastDay: { fr: '31 octobre', en: 'October 31' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Quentin était un missionnaire romain martyrisé en Gaule au IIIe siècle.',
      en: 'Saint Quentin was a Roman missionary martyred in Gaul in the 3rd century.'
    }
  },
  // R
  'rachel': {
    saint: { fr: 'Sainte Rachel', en: 'Saint Rachel' },
    feastDay: { fr: '15 janvier', en: 'January 15' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Rachel était l\'épouse de Jacob dans l\'Ancien Testament, mère de Joseph et Benjamin.',
      en: 'Saint Rachel was Jacob\'s wife in the Old Testament, mother of Joseph and Benjamin.'
    }
  },
  'raphael': {
    saint: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    feastDay: { fr: '29 septembre', en: 'September 29' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'L\'archange Raphaël est l\'ange de la guérison. Son nom signifie "Dieu guérit".',
      en: 'The Archangel Raphael is the angel of healing. His name means "God heals".'
    }
  },
  'raymond': {
    saint: { fr: 'Saint Raymond', en: 'Saint Raymond' },
    feastDay: { fr: '7 janvier', en: 'January 7' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Raymond de Peñafort (1175-1275) était un dominicain espagnol, canoniste et confesseur papal.',
      en: 'Saint Raymond of Peñafort (1175-1275) was a Spanish Dominican, canonist and papal confessor.'
    }
  },
  'remi': {
    saint: { fr: 'Saint Rémi', en: 'Saint Remigius' },
    feastDay: { fr: '15 janvier', en: 'January 15' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Rémi (437-533) était l\'évêque de Reims qui baptisa Clovis, roi des Francs.',
      en: 'Saint Remigius (437-533) was the Bishop of Reims who baptized Clovis, King of the Franks.'
    }
  },
  'renaud': {
    saint: { fr: 'Saint Renaud', en: 'Saint Reynold' },
    feastDay: { fr: '17 septembre', en: 'September 17' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Renaud de Cologne était un ermite du Xe siècle.',
      en: 'Saint Reynold of Cologne was a 10th century hermit.'
    }
  },
  'rene': {
    saint: { fr: 'Saint René', en: 'Saint Renatus' },
    feastDay: { fr: '19 octobre', en: 'October 19' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint René Goupil (1608-1642) était un missionnaire jésuite français martyrisé au Canada.',
      en: 'Saint René Goupil (1608-1642) was a French Jesuit missionary martyred in Canada.'
    }
  },
  'richard': {
    saint: { fr: 'Saint Richard', en: 'Saint Richard' },
    feastDay: { fr: '3 avril', en: 'April 3' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Richard de Chichester (1197-1253) était un évêque anglais connu pour sa sainteté.',
      en: 'Saint Richard of Chichester (1197-1253) was an English bishop known for his holiness.'
    }
  },
  'robert': {
    saint: { fr: 'Saint Robert', en: 'Saint Robert' },
    feastDay: { fr: '17 septembre', en: 'September 17' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Robert Bellarmin (1542-1621) était un cardinal et Docteur de l\'Église.',
      en: 'Saint Robert Bellarmine (1542-1621) was a cardinal and Doctor of the Church.'
    }
  },
  'roger': {
    saint: { fr: 'Saint Roger', en: 'Saint Roger' },
    feastDay: { fr: '1er mars', en: 'March 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Roger de Todi était un évêque du XIIIe siècle en Italie.',
      en: 'Saint Roger of Todi was a 13th century bishop in Italy.'
    }
  },
  'romain': {
    saint: { fr: 'Saint Romain', en: 'Saint Romanus' },
    feastDay: { fr: '23 octobre', en: 'October 23' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Romain de Rouen était un évêque du VIIe siècle, connu pour avoir vaincu un dragon.',
      en: 'Saint Romanus of Rouen was a 7th century bishop, known for defeating a dragon.'
    }
  },
  'rose': {
    saint: { fr: 'Sainte Rose de Lima', en: 'Saint Rose of Lima' },
    feastDay: { fr: '23 août', en: 'August 23' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Rose de Lima (1586-1617) fut la première sainte canonisée des Amériques.',
      en: 'Saint Rose of Lima (1586-1617) was the first canonized saint of the Americas.'
    }
  },
  // S
  'samuel': {
    saint: { fr: 'Saint Samuel', en: 'Saint Samuel' },
    feastDay: { fr: '20 août', en: 'August 20' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Samuel était un prophète et juge d\'Israël dans l\'Ancien Testament.',
      en: 'Saint Samuel was a prophet and judge of Israel in the Old Testament.'
    }
  },
  'sarah': {
    saint: { fr: 'Sainte Sarah', en: 'Saint Sarah' },
    feastDay: { fr: '24 mai', en: 'May 24' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Sarah était l\'épouse d\'Abraham dans l\'Ancien Testament.',
      en: 'Saint Sarah was Abraham\'s wife in the Old Testament.'
    }
  },
  'sebastien': {
    saint: { fr: 'Saint Sébastien', en: 'Saint Sebastian' },
    feastDay: { fr: '20 janvier', en: 'January 20' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Sébastien était un soldat romain martyrisé pour sa foi, patron des athlètes.',
      en: 'Saint Sebastian was a Roman soldier martyred for his faith, patron saint of athletes.'
    }
  },
  'serge': {
    saint: { fr: 'Saint Serge', en: 'Saint Sergius' },
    feastDay: { fr: '8 octobre', en: 'October 8' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Serge de Radonège (1314-1392) était un moine russe, grand réformateur du monachisme.',
      en: 'Saint Sergius of Radonezh (1314-1392) was a Russian monk, great reformer of monasticism.'
    }
  },
  'simon': {
    saint: { fr: 'Saint Simon', en: 'Saint Simon' },
    feastDay: { fr: '28 octobre', en: 'October 28' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Simon le Zélote était l\'un des douze apôtres de Jésus.',
      en: 'Saint Simon the Zealot was one of the twelve apostles of Jesus.'
    }
  },
  'solange': {
    saint: { fr: 'Sainte Solange', en: 'Saint Solange' },
    feastDay: { fr: '10 mai', en: 'May 10' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Solange était une bergère du Berry martyrisée au IXe siècle.',
      en: 'Saint Solange was a shepherdess from Berry martyred in the 9th century.'
    }
  },
  'sophie': {
    saint: { fr: 'Sainte Sophie', en: 'Saint Sophia' },
    feastDay: { fr: '25 mai', en: 'May 25' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Sophie était une martyre romaine du IIe siècle, mère de Foi, Espérance et Charité.',
      en: 'Saint Sophia was a Roman martyr of the 2nd century, mother of Faith, Hope, and Charity.'
    }
  },
  'stephane': {
    saint: { fr: 'Saint Étienne', en: 'Saint Stephen' },
    feastDay: { fr: '26 décembre', en: 'December 26' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Étienne fut le premier martyr chrétien, lapidé à mort pour sa foi.',
      en: 'Saint Stephen was the first Christian martyr, stoned to death for his faith.'
    }
  },
  'sylvain': {
    saint: { fr: 'Saint Sylvain', en: 'Saint Silvanus' },
    feastDay: { fr: '4 mai', en: 'May 4' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Sylvain était un évêque de Gaza au IVe siècle, martyrisé dans les mines.',
      en: 'Saint Silvanus was a bishop of Gaza in the 4th century, martyred in the mines.'
    }
  },
  'sylvie': {
    saint: { fr: 'Sainte Sylvie', en: 'Saint Sylvia' },
    feastDay: { fr: '5 novembre', en: 'November 5' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Sylvie était la mère du pape Saint Grégoire le Grand.',
      en: 'Saint Sylvia was the mother of Pope Saint Gregory the Great.'
    }
  },
  // T
  'therese': {
    saint: { fr: 'Sainte Thérèse de Lisieux', en: 'Saint Thérèse of Lisieux' },
    feastDay: { fr: '1er octobre', en: 'October 1' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Thérèse de Lisieux (1873-1897), la "Petite Fleur", est Docteur de l\'Église.',
      en: 'Saint Thérèse of Lisieux (1873-1897), the "Little Flower", is a Doctor of the Church.'
    }
  },
  'thierry': {
    saint: { fr: 'Saint Thierry', en: 'Saint Theodoric' },
    feastDay: { fr: '1er juillet', en: 'July 1' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Thierry de Reims était un abbé du VIe siècle, disciple de Saint Rémi.',
      en: 'Saint Theodoric of Reims was a 6th century abbot, disciple of Saint Remigius.'
    }
  },
  'thomas': {
    saint: { fr: 'Saint Thomas', en: 'Saint Thomas' },
    feastDay: { fr: '3 juillet', en: 'July 3' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Thomas l\'Apôtre est connu pour avoir douté de la résurrection avant de proclamer sa foi.',
      en: 'Saint Thomas the Apostle is known for doubting the resurrection before proclaiming his faith.'
    }
  },
  'timothee': {
    saint: { fr: 'Saint Timothée', en: 'Saint Timothy' },
    feastDay: { fr: '26 janvier', en: 'January 26' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Timothée était un disciple de Saint Paul et évêque d\'Éphèse.',
      en: 'Saint Timothy was a disciple of Saint Paul and bishop of Ephesus.'
    }
  },
  // U
  'urbain': {
    saint: { fr: 'Saint Urbain', en: 'Saint Urban' },
    feastDay: { fr: '25 mai', en: 'May 25' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Urbain Ier fut pape de 222 à 230, pendant une période de persécutions.',
      en: 'Saint Urban I was pope from 222 to 230, during a period of persecutions.'
    }
  },
  // V
  'valentin': {
    saint: { fr: 'Saint Valentin', en: 'Saint Valentine' },
    feastDay: { fr: '14 février', en: 'February 14' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Valentin de Rome était un prêtre martyrisé au IIIe siècle, patron des amoureux.',
      en: 'Saint Valentine of Rome was a priest martyred in the 3rd century, patron saint of lovers.'
    }
  },
  'valerie': {
    saint: { fr: 'Sainte Valérie', en: 'Saint Valeria' },
    feastDay: { fr: '28 avril', en: 'April 28' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Valérie de Limoges était une vierge et martyre du IIIe siècle en Gaule.',
      en: 'Saint Valeria of Limoges was a virgin and martyr of the 3rd century in Gaul.'
    }
  },
  'veronique': {
    saint: { fr: 'Sainte Véronique', en: 'Saint Veronica' },
    feastDay: { fr: '4 février', en: 'February 4' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Véronique est la femme pieuse qui essuya le visage de Jésus sur le chemin du Calvaire.',
      en: 'Saint Veronica is the pious woman who wiped Jesus\' face on the way to Calvary.'
    }
  },
  'victor': {
    saint: { fr: 'Saint Victor', en: 'Saint Victor' },
    feastDay: { fr: '21 juillet', en: 'July 21' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Victor de Marseille était un soldat romain martyrisé pour sa foi au IIIe siècle.',
      en: 'Saint Victor of Marseilles was a Roman soldier martyred for his faith in the 3rd century.'
    }
  },
  'vincent': {
    saint: { fr: 'Saint Vincent de Paul', en: 'Saint Vincent de Paul' },
    feastDay: { fr: '27 septembre', en: 'September 27' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint Vincent de Paul (1581-1660) est le fondateur des Lazaristes et des Filles de la Charité.',
      en: 'Saint Vincent de Paul (1581-1660) is the founder of the Lazarists and the Daughters of Charity.'
    }
  },
  'virginie': {
    saint: { fr: 'Sainte Virginie', en: 'Saint Virginia' },
    feastDay: { fr: '7 janvier', en: 'January 7' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Virginie était une vierge romaine martyrisée au IIIe siècle.',
      en: 'Saint Virginia was a Roman virgin martyred in the 3rd century.'
    }
  },
  // W
  'william': {
    saint: { fr: 'Saint Guillaume', en: 'Saint William' },
    feastDay: { fr: '10 janvier', en: 'January 10' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Guillaume de Bourges était un archevêque célèbre pour sa sainteté.',
      en: 'Saint William of Bourges was an archbishop famous for his holiness.'
    }
  },
  // X
  'xavier': {
    saint: { fr: 'Saint François Xavier', en: 'Saint Francis Xavier' },
    feastDay: { fr: '3 décembre', en: 'December 3' },
    archangel: { fr: 'Archange Raphaël', en: 'Archangel Raphael' },
    history: {
      fr: 'Saint François Xavier (1506-1552) était un missionnaire jésuite, patron des missions.',
      en: 'Saint Francis Xavier (1506-1552) was a Jesuit missionary, patron saint of missions.'
    }
  },
  // Y
  'yann': {
    saint: { fr: 'Saint Jean', en: 'Saint John' },
    feastDay: { fr: '27 décembre', en: 'December 27' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Yann est la forme bretonne de Jean. Saint Jean l\'Évangéliste était l\'apôtre bien-aimé.',
      en: 'Yann is the Breton form of John. Saint John the Evangelist was the beloved apostle.'
    }
  },
  'yves': {
    saint: { fr: 'Saint Yves', en: 'Saint Ivo' },
    feastDay: { fr: '19 mai', en: 'May 19' },
    archangel: { fr: 'Archange Michel', en: 'Archangel Michael' },
    history: {
      fr: 'Saint Yves (1253-1303) était un prêtre breton, patron des avocats et de la Bretagne.',
      en: 'Saint Ivo (1253-1303) was a Breton priest, patron saint of lawyers and Brittany.'
    }
  },
  'yvette': {
    saint: { fr: 'Sainte Yvette', en: 'Saint Yvette' },
    feastDay: { fr: '13 janvier', en: 'January 13' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Yvette de Huy (1158-1228) était une recluse belge connue pour sa vie mystique.',
      en: 'Saint Yvette of Huy (1158-1228) was a Belgian recluse known for her mystical life.'
    }
  },
  // Z
  'zacharie': {
    saint: { fr: 'Saint Zacharie', en: 'Saint Zechariah' },
    feastDay: { fr: '5 novembre', en: 'November 5' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Saint Zacharie était le père de Saint Jean-Baptiste et un prêtre du Temple.',
      en: 'Saint Zechariah was the father of Saint John the Baptist and a priest of the Temple.'
    }
  },
  'zoe': {
    saint: { fr: 'Sainte Zoé', en: 'Saint Zoe' },
    feastDay: { fr: '2 mai', en: 'May 2' },
    archangel: { fr: 'Archange Gabriel', en: 'Archangel Gabriel' },
    history: {
      fr: 'Sainte Zoé de Rome était une martyre chrétienne du IIIe siècle.',
      en: 'Saint Zoe of Rome was a Christian martyr of the 3rd century.'
    }
  }
};

// Function to search for a saint by name (case insensitive, removes accents)
export const findSaintByName = (name) => {
  if (!name) return null;
  
  // Normalize the name: lowercase, remove accents
  const normalizedName = name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
  
  // Direct match
  if (saintsDatabase[normalizedName]) {
    return saintsDatabase[normalizedName];
  }
  
  // Try to find partial matches
  for (const key of Object.keys(saintsDatabase)) {
    const normalizedKey = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (normalizedKey === normalizedName || normalizedKey.includes(normalizedName) || normalizedName.includes(normalizedKey)) {
      return saintsDatabase[key];
    }
  }
  
  return null;
};

// Get a random saint for suggestions
export const getRandomSaints = (count = 5) => {
  const keys = Object.keys(saintsDatabase);
  const shuffled = keys.sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count).map(key => ({
    name: key.charAt(0).toUpperCase() + key.slice(1),
    ...saintsDatabase[key]
  }));
};

// Get all available names
export const getAllNames = () => {
  return Object.keys(saintsDatabase).map(name => 
    name.charAt(0).toUpperCase() + name.slice(1)
  );
};

export default saintsDatabase;
